export const SFooterPaper = {
  position: 'fixed',
  bottom: 0,
  width: '100%',
  height: '60px',
};
